"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListItemSwitch = exports.ListItem = exports.ListItemCenter = exports.ListItemComponent = exports.List = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importStar(require("styled-components"));
var switch_1 = require("./switch");
var typography_1 = require("./typography");
// Light mode
// const color = {
//   font: '#1f1f21',
//   background: '#fff',
//   divider: '#ccc',
//   highlight: '#d9d9d9',
//   chevron: '#c7c7cc',
// };
// Dark mode
var color = {
    primaryFont: "inherit",
    secondaryFont: "rgba(255, 255, 255, 0.6)",
    // background: '#181818',
    // background: 'var(--bg-color2)',
    background: "none",
    // background: '#1c1c1e;',
    divider: "#242424",
    highlight: "rgba(255, 255, 255, 10%)",
    // highlight: '#2c2c2e',
    // chevron: '#383833',
    chevron: "#5a5a60",
};
/**
 * Helpers
 */
var tappable = styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  transition: background-color 0.2s linear;\n\n  :active {\n    transition: none;\n    background-color: ", ";\n  }\n"], ["\n  transition: background-color 0.2s linear;\n\n  :active {\n    transition: none;\n    background-color: ", ";\n  }\n"])), color.highlight);
var Underlined = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-size: 100% 1px;\n  background-repeat: no-repeat;\n  background-position: bottom;\n  background-image: linear-gradient(\n    0deg,\n    ", " 0%,\n    ", " 50%,\n    transparent 50%\n  );\n"], ["\n  background-size: 100% 1px;\n  background-repeat: no-repeat;\n  background-position: bottom;\n  background-image: linear-gradient(\n    0deg,\n    ", " 0%,\n    ", " 50%,\n    transparent 50%\n  );\n"])), color.divider, color.divider);
/**
 * List
 */
exports.List = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n  user-select: none;\n  font-size: 14px;\n  overflow: hidden;\n  background-color: ", ";\n"], ["\n  color: ", ";\n  user-select: none;\n  font-size: 14px;\n  overflow: hidden;\n  background-color: ", ";\n"])), color.primaryFont, color.background);
/**
 * ListItemComponent
 */
exports.ListItemComponent = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  padding-left: 14px;\n  min-height: 44px;\n  ", "\n"], ["\n  display: flex;\n  padding-left: 14px;\n  min-height: 44px;\n  ", "\n"])), function (props) { return (props.onClick ? tappable : ""); });
/**
 * ListItemLeft
 */
var ListItemLeft = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  height: 40px;\n  widows: 40px;\n  margin: 12px 0;\n  margin-right: 14px;\n  border-radius: 6px;\n  /* background-color: #1f1f21; */\n  background-color: #8e8e93;\n"], ["\n  height: 40px;\n  widows: 40px;\n  margin: 12px 0;\n  margin-right: 14px;\n  border-radius: 6px;\n  /* background-color: #1f1f21; */\n  background-color: #8e8e93;\n"])));
/**
 * ListItemCenter
 */
exports.ListItemCenter = styled_components_1.default(Underlined)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  flex-grow: 1;\n  padding-right: 14px;\n  padding-top: 12px;\n  padding-bottom: 12px;\n  overflow: hidden;\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  flex-grow: 1;\n  padding-right: 14px;\n  padding-top: 12px;\n  padding-bottom: 12px;\n  overflow: hidden;\n"])));
/**
 * ListItemTitle
 *
 * Child of ListItemCenter
 */
var ListItemTitle = styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  height: 19px;\n  font-size: 16px;\n"], ["\n  display: flex;\n  align-items: center;\n  height: 19px;\n  font-size: 16px;\n"])));
/**
 * ListItemSubtitle
 *
 * Child of ListItemCenter
 */
var ListItemSubtitle = styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  height: 19px;\n  color: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  height: 19px;\n  color: ", ";\n"])), color.secondaryFont);
/**
 * ListItemRight
 */
var ListItemRight = styled_components_1.default(Underlined)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  padding-right: 14px;\n  padding-top: 12px;\n  padding-bottom: 12px;\n  color: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  padding-right: 14px;\n  padding-top: 12px;\n  padding-bottom: 12px;\n  color: ", ";\n"])), color.secondaryFont);
/**
 * Label
 */
var Label = styled_components_1.default(ListItemRight)(templateObject_10 || (templateObject_10 = __makeTemplateObject([""], [""])));
/**
 * Chevron
 */
var Chevron = styled_components_1.default(ListItemRight)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  margin-left: -6px;\n\n  :before {\n    content: \"\";\n    border-right: 2px solid ", ";\n    border-bottom: 2px solid ", ";\n    width: 7px;\n    height: 7px;\n    transform: rotate(-45deg);\n  }\n"], ["\n  margin-left: -6px;\n\n  :before {\n    content: \"\";\n    border-right: 2px solid ", ";\n    border-bottom: 2px solid ", ";\n    width: 7px;\n    height: 7px;\n    transform: rotate(-45deg);\n  }\n"])), color.chevron, color.chevron);
/**
 * Ellipsis
 */
var Ellipsis = styled_components_1.default.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"], ["\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])));
var Icon = styled_components_1.default.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  height: 40px;\n  width: 40px;\n"], ["\n  height: 40px;\n  width: 40px;\n"])));
function ListItem(props) {
    return (jsx_runtime_1.jsxs(exports.ListItemComponent, __assign({ "data-test": props["data-test"], onClick: props.onClick }, { children: [props.left && (jsx_runtime_1.jsx(ListItemLeft, { children: jsx_runtime_1.jsx(Icon, { children: props.left }, void 0) }, void 0)),
            jsx_runtime_1.jsxs(exports.ListItemCenter, { children: [jsx_runtime_1.jsx(ListItemTitle, { children: props.wrapPrimary ? (jsx_runtime_1.jsx(typography_1.EllipsisThreeLines, { children: props.primary }, void 0)) : (jsx_runtime_1.jsx(Ellipsis, { children: props.primary }, void 0)) }, void 0),
                    !props.wrapPrimary && props.secondary && (jsx_runtime_1.jsx(ListItemSubtitle, { children: jsx_runtime_1.jsx(Ellipsis, { children: props.secondary }, void 0) }, void 0))] }, void 0),
            props.label && jsx_runtime_1.jsx(Label, { children: props.label }, void 0),
            props.chevron && jsx_runtime_1.jsx(Chevron, {}, void 0)] }), void 0));
}
exports.ListItem = ListItem;
function ListItemSwitch(props) {
    return (jsx_runtime_1.jsxs(exports.ListItemComponent, __assign({ "data-test": props["data-test"] }, { children: [props.left && (jsx_runtime_1.jsx(ListItemLeft, { children: jsx_runtime_1.jsx(Icon, { children: props.left }, void 0) }, void 0)),
            jsx_runtime_1.jsxs(exports.ListItemCenter, { children: [jsx_runtime_1.jsx(ListItemTitle, { children: props.wrapPrimary ? (jsx_runtime_1.jsx(typography_1.EllipsisThreeLines, { children: props.primary }, void 0)) : (jsx_runtime_1.jsx(Ellipsis, { children: props.primary }, void 0)) }, void 0),
                    !props.wrapPrimary && props.secondary && (jsx_runtime_1.jsx(ListItemSubtitle, { children: jsx_runtime_1.jsx(Ellipsis, { children: props.secondary }, void 0) }, void 0))] }, void 0),
            jsx_runtime_1.jsx(Label, { children: jsx_runtime_1.jsx(switch_1.Switch, { checked: props.checked, disabled: typeof props.onClick !== "function", onClick: props.onClick }, void 0) }, void 0)] }), void 0));
}
exports.ListItemSwitch = ListItemSwitch;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;
//# sourceMappingURL=list.js.map